<template>
  <div>
    <v-row no-gutters justify="center">
      <v-col class="py-0">
        <v-row no-gutters class="py-0">
          <v-col class="pl-3">
            <v-row no-gutters>
              <v-col class="py-0">
                <v-row no-gutters justify="center">
                  <v-expansion-panels
                    accordion
                    :value="expanded"
                    multiple
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="my-1" color="accent">
                        <p
                          depressed
                          class="font-weight-bold text-left text-uppercase text-customizer-exp"
                        >
                          {{ this.$t("page.events.registration.registeredParticipants") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <RegistrationList v-bind:participants="participants"/>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="my-1" color="accent">
                        <p
                          depressed
                          class="font-weight-bold text-left text-uppercase text-customizer-exp"
                        >
                          {{ this.$t("page.events.registration.deletedParticipants") }}
                        </p>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <RegistrationList v-bind:participants="deletedParticipants"/>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import RegistrationList from "@/components/dashboard/registration/RegistrationList.vue";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  name: "Registration",
  mixins: [apiCalls],
  components: {
    RegistrationList
  },
  data() {
    return {
      event: [],
      eventId: this.$route.params.id,
      expanded: [],
      participants: [],
      deletedParticipants: []
    };
  },
  asyncComputed: {
    eventResponse: async function () {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEvent/" + this.$route.params.id
      );
      this.event = response.message[0];
      this.expanded = [0];
      return response;
    },
  },
  methods: {
    loadParticipants: async function () {
      let participants = [];
      const response = await this.api(
        "get",
        `/api/v1/promoter/event/${this.eventId}/participants`
      );

      participants = response.length > 0 ? response.map( elem => {
        const regBy = elem.byFirstName || elem.byLastName ? `${elem.regBy}` : null;
        return {
          ...elem,
          regBy
        };
      }) : [];

      this.participants = participants;
    },
    loadDeletedParticipants: async function () {
      let participants = [];
      const response = await this.api(
        "get",
        `/api/v1/promoter/event/${this.eventId}/deletedparticipants`
      );

      participants = response.length > 0 ? response.map( elem => {
        const regBy = elem.byFirstName || elem.byLastName ? `${elem.regBy}` : null;
        return {
          ...elem,
          regBy
        };
      }) : [];

      this.deletedParticipants = participants;
    },
  },
  mounted() {
    this.loadParticipants();
    this.loadDeletedParticipants();
  },
};
</script>

<style>
.tabulator-placeholder {
  width: 0px;
  overflow-y: hidden;
}
.color-check {
  color: var(--v-success-base);
}
.color-failed {
  color: var(--v-error-base);
}
</style>
